import '@angular/compiler';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageDocsComponent } from './page.docs/page.docs.component';
import { PageDocsFormComponent } from './page.docs.form/page.docs.form.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageDocsHistoryComponent } from './page.docs.history/page.docs.history.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';

const INDEX_PAGE = "access";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "docs",
                component: PageDocsComponent,
                "app_id": "page.docs"
            },
            {
                "path": "docs/form/:template_id",
                component: PageDocsFormComponent,
                "app_id": "page.docs.form"
            },
            {
                "path": "docs/history",
                component: PageDocsHistoryComponent,
                "app_id": "page.docs.history"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            },
            {
                "path": "signup",
                component: PageSignupComponent,
                "app_id": "page.signup"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let routePriority = (path: any) => {
    let segments = String(path || "").split('/').filter((segment: string) => segment.length > 0);
    let staticCount = 0;
    let dynamicCount = 0;
    let optionalCount = 0;
    let literalLength = 0;

    for (let i = 0; i < segments.length; i++) {
        let segment = segments[i];
        literalLength += segment.length;

        if (segment.startsWith(':')) {
            dynamicCount += 1;
            if (segment.endsWith('?')) {
                optionalCount += 1;
            }
            continue;
        }

        staticCount += 1;
    }

    return {
        staticCount,
        dynamicCount,
        optionalCount,
        segmentCount: segments.length,
        literalLength
    };
}

// Prefer more specific static paths so /docs/history is not swallowed by /docs/:template_id.
let sortRouteChildren = (children: any[]) => {
    return [...children].sort((left: any, right: any) => {
        let a = routePriority(left.path);
        let b = routePriority(right.path);

        if (a.staticCount !== b.staticCount) return b.staticCount - a.staticCount;
        if (a.dynamicCount !== b.dynamicCount) return a.dynamicCount - b.dynamicCount;
        if (a.optionalCount !== b.optionalCount) return a.optionalCount - b.optionalCount;
        if (a.segmentCount !== b.segmentCount) return b.segmentCount - a.segmentCount;
        return b.literalLength - a.literalLength;
    });
}

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = sortRouteChildren(layout.children || []);
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = sortRouteChildren(layout.children || []);

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }